import { ORDER_VIEWS } from './permissions';

export const ORDER_VIEW_FILTERS = {
	unpaid: {
		is_payment_confirmed: 0,
		is_status_completed: 0,
	},
	'not-started': {
		is_status_being_prepared: 0,
		is_status_prepared: 0,
		is_status_completed: 0,
		is_payment_confirmed: 1,
	},
	unassigned: {
		is_shopper_assigned: 0,
		is_provider_assigned: 0,
		is_status_canceled: 0,
		is_status_expired: 0,
		is_status_prepared: 0,
		is_status_being_prepared: 1,
	},
	cancelled: {
		is_status_canceled: 1,
	},
};

export const getOrderViewQuery = (orderType) =>
	Object.entries(ORDER_VIEW_FILTERS[orderType] || {})
		.map(([key, value]) => `${key}=${value}`)
		.join('&');

export const getOrderListViewType = (pathname) => {
	const segment = (pathname || '').split('/')[1];
	const view = ORDER_VIEWS.find(v => v.fullUrl === segment);
	return view ? view.type : null;
};

export const orderMatchesView = (order, orderType) => {
	const filters = ORDER_VIEW_FILTERS[orderType];
	if (!filters) return true;

	return Object.entries(filters).every(([key, value]) => Number(!!order[key]) === value);
};



// WEBPACK FOOTER //
// ./src/utils/orderViewFilters.js